import Vue from 'vue'

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Print from 'vue-print-nb'
Vue.use(Print); //注册
import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
//打印
import print from "./plugs/print"
Vue.use(print) // 注册

// 注册自定义滚动条插件
import "overlayscrollbars/css/OverlayScrollbars.css";
import OverlayScrollbars from "overlayscrollbars";
import { OverlayScrollbarsPlugin } from "overlayscrollbars-vue";
Vue.use(OverlayScrollbarsPlugin);
Vue.use(OverlayScrollbars);


import lodash from 'lodash'

import i18n from './lang' // Internationalization
import '@/icons' // icon
import '@/permission' // permission control

import * as filters from './filters' // global filters

import utils from '../static/utils/utils.js'

import constant from '../static/utils/constant.js'

import { exportExcel } from '@/utils/exportExcel.js'

// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import histogram from 'v-charts/lib/histogram.common'
Vue.component(histogram.name, histogram)


Vue.use(VueQuillEditor)

import vueParticleLine from 'vue-particle-line'
import 'vue-particle-line/dist/vue-particle-line.css'
Vue.use(vueParticleLine)

Vue.prototype.absolute_path = __dirname

// bus
const bus = new Vue()
Vue.prototype.bus = bus

// lodash
Vue.prototype.$lodash = lodash

// exportExcel
Vue.prototype.$exportExcel = exportExcel

Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium',
    i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

Vue.use(utils)

Vue.use(constant)

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})